// app/src/contexts/ScaleContextDesktop.tsx

import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface ScaleContextProps {
	scaleDesktop: number;
}

const ScaleContextDesktop = createContext<ScaleContextProps>({ scaleDesktop: 1 });

export const ScaleProviderDesktop: React.FC<{ children: ReactNode }> = ({ children }) => {
	const baseWidth = 1800;
	const [scaleDesktop, setScaleDesktop] = useState(1);
	
	useEffect(() => {
		const handleResize = () => {
			const viewportWidth = window.innerWidth;
			const newScale = viewportWidth / baseWidth;
			
			const minScale = 0.3;
			const maxScale = 1.5;
			const clampedScale = Math.max(minScale, Math.min(newScale, maxScale));
			
			setScaleDesktop(clampedScale);
		};
		
		handleResize();
		window.addEventListener('resize', handleResize);
		
		return () => window.removeEventListener('resize', handleResize);
	}, []);
	
	return (
		<ScaleContextDesktop.Provider value={{ scaleDesktop: scaleDesktop }}>
			{children}
		</ScaleContextDesktop.Provider>
	);
};

export const useScaleDesktop = () => useContext(ScaleContextDesktop);
